import { useEffect, useState } from "react";

const MobileScreen = () => {
  const [count, setCount] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => {
        if (prev === 0) {
          clearInterval(timer); // Stop the countdown at 0
          if (getMobileOperatingSystem() === "iOS") {
            window.location.href =
              "https://apps.apple.com/in/app/1-club/id1631535570";
          } else {
            window.location.href =
              "https://play.google.com/store/search?q=1%25%20club&c=apps";
          }
          return prev;
        }
        return prev - 1; // Decrement the count
      });
    }, 1000); // 1000ms = 1 second

    return () => clearInterval(timer); // Cleanup on component unmount
  }, []);

  const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return "iOS";
    }

    return "unknown";
  };

  const handleOpenStore = () => {
    if (getMobileOperatingSystem() === "iOS") {
      window.location.href =
        "https://apps.apple.com/in/app/1-club/id1631535570";
    } else {
      window.location.href =
        "https://play.google.com/store/search?q=1%25%20club&c=apps";
    }
  };

  return (
    <div className="flex overflow-hidden flex-col mx-auto w-full font-bold text-white bg-neutral-950 max-w-[480px]">
      <div className="flex relative flex-col w-full h-screen justify-center items-center">
        <img
          loading="lazy"
          src="/assets/background-hash.svg"
          alt="Background"
          className="object-cover absolute inset-0 size-full"
        />
        <img
          loading="lazy"
          src="/assets/download-store.svg"
          alt="Store preview"
          className="object-contain max-w-full aspect-[1.54] w-[219px] ml-[-10px]"
        />
        <div className="relative mt-14 text-3xl tracking-wide leading-none text-center">
          Redirecting to Store
        </div>
        <div className="relative mt-2 text-lg tracking-normal text-center text-stone-300">
          Opening store in {count} seconds...
        </div>
        <button
          onClick={handleOpenStore}
          className="overflow-hidden relative px-16 py-3.5 mt-16 mb-0 max-w-full text-base tracking-tight leading-none bg-blue-600 rounded-xl shadow-[-4px_-4px_10px_rgba(189,189,189,0.2)] w-[223px]"
        >
          Open Store
        </button>
      </div>
    </div>
  );
};

export default MobileScreen;
